import { render, staticRenderFns } from "./mainGroup.vue?vue&type=template&id=73a0716e&scoped=true&"
import script from "./mainGroup.vue?vue&type=script&lang=js&"
export * from "./mainGroup.vue?vue&type=script&lang=js&"
import style0 from "./mainGroup.vue?vue&type=style&index=0&id=73a0716e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a0716e",
  null
  
)

export default component.exports